<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt"  getUrl="/web/setting/shiftType/page"
			getKey="rows" :columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('banzhimingcheng')">
						<el-input v-model="yt.conditions.name"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary"
							plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear()">{{$t('chongzhi')}}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" v-if="utils.checkPower('web_base_shift_create')" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('banci', scope.row,'90%')">{{$t('banci')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" v-if="utils.checkPower('web_base_shift_update')"  @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" :loading="yt.editObj.loading" v-if="utils.checkPower('web_base_shift_delete')" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/setting/shiftType/delete')">{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('banzhibianma')" required="required">
						<el-input v-model="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('banzhimingcheng')" required="required">
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('suoshuzuzhi')">
						<yi_data_select :type="'organization'"  :ids.sync="yt.editObj.orgId">
						</yi_data_select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/setting/shiftType/create')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">

					<el-form-item :label="$t('banzhibianma')" required="required">
						<el-input v-model="yt.editObj.code" disabled></el-input>
					</el-form-item>
					<el-form-item :label="$t('banzhimingcheng')" required="required">
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('suoshuzuzhi')">
						<yi_data_select :type="'organization'"  :ids.sync="yt.editObj.orgId" disabled>
						</yi_data_select>
					</el-form-item>

				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/setting/shiftType/update')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 班次 -->
			<template v-if="yt.editObj.action == 'banci'">
				<div class="dialog-scroller">
					<shift_setting :shift="yt.editObj"></shift_setting>
				</div>
			</template>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	import shift_setting from '@@/pages/web/base/shift/shift_setting'
	export default {
		name: 'web_base_shift_shift_setting',
		components: {
			shift_setting
		},
		data() {
			return {
				list: [],
				// organizationList: [],
				columns: [{
					label: 'banzhibianma',
					prop: 'code',
					width: 130
				}, {
					label: 'banzhimingcheng',
					prop: 'name',
					width: 130
				}, {
					label: 'suoshuzuzhi',
					prop: 'orgName',
				}, {
					label: 'chuangjianshijian',
					prop: 'createTime',
					type: 'time',
					// format: 'yyyy-MM-dd:hh:mm:ss'
				}, {
					label: 'xiugaishijian',
					prop: 'updateTime',
					type: 'time',
					// format: 'yyyy-MM-dd:hh:mm:ss'
				}, {
					label: 'caozuo',
					type: 'slot',
					width: 180,
					fixed: 'right'
				}]
			};
		},
		created() {
			setTimeout(() => {
				this.yt.get(1);
				// this.getOrganizationList();
			}, 300)

		},
		methods: {
			// async getOrganizationList() {
			// 	let response = await this.http.get('/web/setting/org/page', {
			// 		params: {
			// 			pageNum: 1,
			// 			pageSize: 1000
			// 		}
			// 	})
			// 	this.organizationList = response.data.rows
			// },
			// 重置
			clear() {
				this.yt.conditions = {
					pageNum: 1,
					pageSize: 10
				}
				this.yt.get(1)
			},
		}
	};
</script>
